import { useTranslation } from 'react-i18next';
import { formatCurrency } from '../../utils';
import { BookingCancellationFee } from '../../types/bookingCreation';

/**
 * The cancellation fee of a cancelled booking, in the facts column of the
 * detail page (M10, W1-6, #3042): "Stornogebühr: 50 % = 120,00 €", "Stornogebühr
 * erlassen", or "kostenfrei storniert" under a rule that charged nothing yet.
 * Nothing when the booking was not cancelled under a rule.
 *
 * Shared by the venue, apartment and station-unit detail pages.
 */
const CancellationFeeInfo = ({ fee }: { fee?: BookingCancellationFee | null }) => {
    const { t, i18n } = useTranslation();
    if (!fee) return null;
    if (fee.waived) {
        return <p className={'text-sm text-foreground/60 mt-1'}>{t('booking_details.cancellation_fee.info_waived')}</p>;
    }
    if (fee.amount <= 0) {
        return <p className={'text-sm text-foreground/60 mt-1'}>{t('booking_details.cancellation_fee.info_free')}</p>;
    }
    const amount = formatCurrency(fee.amount, i18n.language);
    return (
        <p className={'text-sm text-foreground/60 mt-1'}>
            {t('booking_details.cancellation_fee.header')}:{' '}
            <span className={'font-bold'}>{fee.percent === null ? amount : `${fee.percent} % = ${amount}`}</span>
        </p>
    );
};

export default CancellationFeeInfo;
